import { observer } from "mobx-react";
import currentPortalStore from "../../../../stores/current-portal-store";
import EditorPageLayout from "../../../../components/layouts/editor-page/editor-page-layout";
import GridLineLayout from "../../../../components/layouts/grid-line-layout/grid-line-layout";
import GridLine from "../../../../components/layouts/grid-line-layout/grid-line/grid-line";
import { useNavigate } from "react-router-dom";
import GridLineItem from "../../../../components/layouts/grid-line-layout/grid-line/grid-line-item/grid-line-item";
import { FONT_COLOR, FONT_VARIANT } from "../../../../components/fonts/font-props";
import FontBody1 from "../../../../components/fonts/font-body1/font-body1";
import GridLineIndicators from "../../../../components/layouts/grid-line-layout/grid-line/grid-line-indicators/grid-line-indicators";
import GridLineButtons from "../../../../components/layouts/grid-line-layout/grid-line/grid-line-buttons/grid-line-buttons";
import { ButtonIcon } from "../../../../components/inputs/button-icon/button-icon";
import IconEdit from "../../../../components/icons/icon-edit/icon-edit";
import FontBody2 from "../../../../components/fonts/font-body2/font-body2";
import { FEATURES } from "../../../../models/Plan";
import usePage from "../../../../components/layouts/base-page-layout/page-hook";
import { useEffect } from "react";
import PreviewLink from "../../../../components/preview-link/preview-link";


const LookAndFeelSettingsBlockList: React.FC = observer(() => {
    const navigate = useNavigate();
    const { setSubTitles } = usePage();

    useEffect(() => {
        setSubTitles(['Portal', 'Look and Feel']);
    }, [setSubTitles]);

    const settingsBlockList = [
        {
            title: 'General Settings',
            pathname: 'general-settings',
            disabled: false,
            previewLink: <></>,
        },
        {
            title: 'Return Portal',
            pathname: 'return-portal',
            previewLink: <PreviewLink disabled={!currentPortalStore.setting} href={currentPortalStore.setting?.returnsPortalPreviewLink} />,
            disabled: false,
        },
        {
            title: 'Tracking Portal',
            pathname: 'tracking-portal',
            disabled: !currentPortalStore.isFeatureAllowed(FEATURES.ORDER_TRACKING),
            previewLink: <PreviewLink disabled={!currentPortalStore.setting} href={currentPortalStore.setting?.trackingPortalPreviewLink} />,
            disabledTooltip: {
                content: (
                    <FontBody2 color={FONT_COLOR.NEUTRAL_WHITE}>
                        The tracking portal feature is <br />
                        not included in your <br />
                        subscription plan. To activate <br />
                        this feature, contact support.
                    </FontBody2>
                )
            },
        },
    ];

    const onOptionClicked = (pathname: string) => {
        navigate({
            pathname: pathname
        });
    };

    return (
        <EditorPageLayout toolbar={{
            hasLocalesSelector: false,
            hasBack:false,
        }}>
            <GridLineLayout>
                {settingsBlockList.map((settingsBlock, index) => (
                    <GridLine
                        key={index}
                        onClick={() => onOptionClicked(settingsBlock.pathname)}
                        settings={{
                            columns: [{ width: 2 }, { width: 30, type: 'px' }, { width: 70, type: 'px' }, { width: 60, type: 'px' }]
                        }}
                        disabled={settingsBlock.disabled}
                        disabledTooltip={settingsBlock.disabledTooltip}
                        columns={[
                            <GridLineItem>
                                <FontBody1 color={FONT_COLOR.PRIMARY2} variant={[FONT_VARIANT.BOLD]}>{settingsBlock.title}</FontBody1>
                            </GridLineItem>,

                            <GridLineIndicators>
                            </GridLineIndicators>,

                            <GridLineItem>
                                {settingsBlock.previewLink}
                            </GridLineItem>,

                            <GridLineButtons>
                                <ButtonIcon Component={IconEdit} onClick={() => onOptionClicked(settingsBlock.pathname)} />
                            </GridLineButtons>,
                        ]} />
                ))}
            </GridLineLayout>
        </EditorPageLayout>
    );
});

export default LookAndFeelSettingsBlockList;
